<div class="reports-statements-section" *ngIf="isOneTimeCloseAccount" id="reports-statements-section">
    <p class="reportsStatementsTitle">Reports and statements you'd like us to send</p>
    <div class="checkboxContainer">
        <input type="checkbox" [formControl]="taxForms" id="taxFormsCheckbox" class="taxFormsCheckbox" (change)="onCheckBoxChanged('taxForms')">
        <label for="taxFormsCheckbox" class="checkboxLabel">Tax forms</label>
        <div *ngIf="taxFormsSelected" class="expandable expandable--taxforms">
            <span data-testid="checkboxAdditionalText" class="checkboxAdditionalText">{{constants.taxFormsText}}</span>
            <input class="sdps-input sdps-input--small" 
            data-testid="tax-forms-date-input"
            placeholder="yyyy" 
            (keydown)="validationService.validateNumberInput($event, taxFormsAllowedChars)"
            maxlength="4" 
            [class.error-input]="taxFormsDateInputControl.invalid && taxFormsDateInputControl.touched" 
            [formControl]="taxFormsDateInputControl"
            />
            <div class="below-account-container" *ngIf="taxFormsDateInputControl.invalid && taxFormsDateInputControl.touched">
                <div class="alert-text">
                    Enter a valid year.
                </div>
            </div>
        </div>
    </div>
    <div class="checkboxContainer">
        <input type="checkbox" [formControl]="accountStatements" id="accountStatementsCheckbox" class="accountStatementsCheckbox" (change)="onCheckBoxChanged('accountStatements')">
        <label for="accountStatementsCheckbox" class="checkboxLabel">Account statements</label>
        <div *ngIf="accountStatementsSelected" class="expandable expandable--accountstatements">
            <span class="checkboxAdditionalText">{{constants.accountStatementstext}}</span>
            <input 
                max="9999-12" 
                class="sdps-input sdps-input--small"
                data-testid="account-statements-date-input"
                type="month"
                [class.error-input]="accountStatementsDateInputControl.invalid && accountStatementsDateInputControl.touched"
                [formControl]="accountStatementsDateInputControl"
            />
            <div class="below-account-container" *ngIf="accountStatementsDateInputControl.invalid && accountStatementsDateInputControl.touched">
                <div class="alert-text"  data-testid="account-statements-date-input-error">
                    Enter a valid date.
                </div>
            </div>
        </div>
    </div>
    <div class="checkboxContainer">
        <input type="checkbox" [formControl]="tradeConfirmations" id="tradeConfirmationsCheckbox" class="tradeConfirmationsCheckbox" (change)="onCheckBoxChanged('tradeConfirmations')">
        <label for="tradeConfirmationsCheckbox" class="checkboxLabel">Trade confirmations</label>
        <div *ngIf="tradeConfirmationsSelected" class="expandable expandable--tradeconf">
            <span class="checkboxAdditionalText">{{constants.tradeConfirmationsText}}</span>
            <input 
            max="9999-12-31"
            class="sdps-input sdps-input--small" 
            data-testid="trade-confirmations-date-input"
            type="date"
            [class.error-input]="tradeConfirmationsDateInputControl.invalid && tradeConfirmationsDateInputControl.touched" 
            [formControl]="tradeConfirmationsDateInputControl"
            />
            <div class="below-account-container" *ngIf="tradeConfirmationsDateInputControl.invalid && tradeConfirmationsDateInputControl.touched">
                <div class="alert-text">
                    Please enter a valid date in MM/DD/YYYY format.
                </div>
            </div>
        </div>
    </div>
</div>